// формат времени лекции
export const formatLectureTime = (ms: number) => {
	let remain = ms;

	const hours = Math.floor(remain / (1000 * 60 * 60));
	remain = remain % (1000 * 60 * 60);

	const minutes = Math.floor(remain / (1000 * 60));
	remain = remain % (1000 * 60);

	const seconds = Math.floor(remain / 1000);

	const getFormattedUnit = (unit: number) => {
		return unit < 10 ? `0${unit}` : unit;
	};

	if (hours >= 1) {
		return `${getFormattedUnit(hours)}:${getFormattedUnit(minutes)}:${getFormattedUnit(seconds)}`;
	}

	if (hours < 1) {
		return `${getFormattedUnit(minutes)}:${getFormattedUnit(seconds)}`;
	}

	return "";
};
